export default "__VITE_ASSET__Bku4T7QA__"